import script from "./downloadBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./downloadBtn.vue?vue&type=script&setup=true&lang=ts"

import "./downloadBtn.vue?vue&type=style&index=0&id=9e9b6664&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\shiyu\\local_document\\projects\\vue\\hsmkai.github.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e9b6664"]])

export default __exports__
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageSticky,QBtn,QTooltip,QDialog,QCard,QCardSection,QSpace,QSeparator,QScrollArea,QCardActions});qInstall(script, 'directives', {ClosePopup});
